import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-update-organization',
  templateUrl: './update-organization.component.html',
  styleUrls: ['./update-organization.component.scss'],
})
export class UpdateOrganizationComponent implements OnInit {

  @ViewChild('companyLogo') _companyLogo: ElementRef;
  breadcrumbList = [
    {
      label: 'Organization',
      embedurl: true,
      url: '/baseapp/organization'
    },
    {
      label: 'Update',
      embedurl: false,
      url: ''
    }
  ];
  countries:any = [];
  orgObj;
  updateOrgform: UntypedFormGroup;
  submitted: boolean = false;
  hide1200: boolean = false;
  userIp;
  isEnableCompanyLogoChanges: boolean = false;
  imagePath: SafeUrl = "../assets/images/default-company-logo.svg";
  selectedFileBlob;
  isCompanyLogoPresentInServer: boolean = false;
  companyLogoId;
  organizationId;
  countriesApi: any;
  editApi: any;
  jobTitle;
  employee;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    private route: ActivatedRoute,
    public storage: Storage,
    private sanitizer: DomSanitizer,
    public helperService: HelperService) { }

  ngOnInit() {
    this.jobTitle = this.helperService.jobTitle;
    this.employee = this.helperService.employee;

    this.getcountries();
    this.updateOrgform = this.formBuilder.group({
      'firstName': ['', Validators.required],
      'lastName': ['', Validators.required],
      'email': ['', [Validators.required, Validators.email]],
      'phone': ['', [Validators.required,Validators.pattern('^[0-9+(][0-9-+(). ]*$'),
      Validators.minLength(10), Validators.maxLength(18)]],
      'jobTitle': ['', Validators.required],
      'employee': ['', Validators.required],
      'company': ['', Validators.required],
      'country': ['', Validators.required],
      'company_address': ['']
    });

    this.breakpointObserver.observe(['(min-width: 1200px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.hide1200 = true;
      } else {
        this.hide1200 = false;
      }
    });

    this.organizationId = this.route.snapshot.params['id'];
    this.getUserIp();
    this.getOrgDetails(this.organizationId);
  }

  get f() { return this.updateOrgform.controls; }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      userId: await this.storage.get("id")
    }
    return data;
  }

  getUserIp(){
    this.backendService.getUserIp().subscribe(
      (data) => {
        const e: any = data as any;
        //console.log(e);
        this.userIp = e.ip;
    })
  }

  getcountries(){
    this.helperService.loader();
     this.countriesApi = this.backendService.Get('getAllCountries').subscribe(
        (data) => {
          this.countries = data;
          this.helperService.closeLoader();
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
  }

  getOrgDetails(user_id){
    this.helperService.loader();
    this.getStorage().then((_storage)=>{
      let payload = {
        ID: user_id
      }

     this.editApi =  this.backendService.PostAPICall('editApiOrganization', payload, _storage.token).subscribe(
        (data) => {
          let res = data[0];
          this.orgObj = res;
          this.helperService.closeLoader();
          
          this.updateOrgform.patchValue(
          {
            firstName: res.first_name,
            lastName: res.last_name,
            email: res.email,
            phone: res.phone_no,
            company: res.company,
            company_address: res.company_address
          })
          this.companyLogoId = res.company_logo;
          this.isCompanyLogoPresentInServer = res.company_logo == null? false:true;  

          let jobTitle = this.jobTitle.filter(function (entry) { return entry.name === res.job_title; });
          this.updateOrgform.controls['jobTitle'].setValue(jobTitle[0].name);
          let employee = this.employee.filter(function (entry) { return entry.name === res.employee; });
          this.updateOrgform.controls['employee'].setValue(employee[0].name);

          let country = this.countries.filter(function (entry) { return entry.country_name === res.country; });
          this.updateOrgform.controls['country'].setValue(country[0].country_name);
          if(this.companyLogoId != null){
            this.getCompanyLogo(this.companyLogoId);
          }
          if(res.subscription_start_date != null){
            let date_string = new Date(res.subscription_start_date);
            let d = moment(date_string, "MMM DD,YYYY");
            this.updateOrgform.addControl('subscriptionStartDate', new UntypedFormControl(""));
            this.updateOrgform.controls['subscriptionStartDate'].setValue(d);
          }
          if(res.subscription_end_date != null){
            let date_string = new Date(res.subscription_end_date);
            let d = moment(date_string, "MMM DD,YYYY");
            this.updateOrgform.addControl('subscriptionEndDate', new UntypedFormControl(""));
            this.updateOrgform.controls['subscriptionEndDate'].setValue(d);
          }
          

        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  

  clearCompanyLogo(){
    this._companyLogo.nativeElement.value = '';
    this.isEnableCompanyLogoChanges = false;
    this.imagePath = "../assets/images/default-company-logo.svg";
  }

  getCompanyLogo(id){
    this.getStorage().then((res)=>{
      let payload = {
        "img_collection_id": id
      }
      let method = 'post';
      this.backendService.fileUpload('getLogoImage', method, payload, res.token).subscribe(
        (data: any) => {
          this.imagePath = 'data:image/jpg;base64,' + data.logo_hash;
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  uploadCompanyLogo(event:any) {
    if(event.target.files && event.target.files[0]) {
      if(event.target.files[0].type && event.target.files[0].type.split('/')[0] == "image" && event.target.files[0].size <= 100000){
        this.selectedFileBlob = event.target.files[0];
        var reader = new FileReader();
        reader.onload = (event:any) => {
          this.isEnableCompanyLogoChanges = true;
          this.imagePath = this.sanitizer.bypassSecurityTrustResourceUrl(event.target.result);
        }
        reader.readAsDataURL(event.target.files[0]);
      } else {
        this._companyLogo.nativeElement.value = '';
        this.helperService.presentToast("Max image upload size is 100KB only", 3000);
      }
    }
  }

  addNewCompanyLogo(){
    this.getStorage().then((res)=>{
      const payload = new FormData();
      payload.append('logo', this.selectedFileBlob);
      payload.append('organization_id', this.organizationId);
      let method = 'post';
      this.backendService.fileUpload('saveCompanyLogo', method, payload, res.token).subscribe(
        (data) => {
          // this.helperService.closeLoader();
          // this.helperService.presentToast(data.msg, 2000);
          // this.router.navigate(['/baseapp/organization']);
        },
        (error)=>{
          //console.log(error);
          // this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  updateExistingCompanyLogo(){
    this.getStorage().then((res)=>{
      const payload = new FormData();
      payload.append('logo', this.selectedFileBlob);
      payload.append('img_collection_id', this.companyLogoId);
      let method = 'put';
      this.backendService.fileUpload('updateCompanyLogo', method, payload, res.token).subscribe(
        (data) => {
          // this.helperService.closeLoader();
          // this.helperService.presentToast(data.msg, 2000);
          // this.router.navigate(['/baseapp/organization']);
        },
        (error)=>{
          //console.log(error);
          // this.helperService.closeLoader();
          this.helperService.handleError(error);
        }
      );
    })
  }

  onSubmit(){
    if (this.updateOrgform.invalid) {
      this.helperService.presentToast("Form incomplete", 2000);
      return;
    }
    
    this.getStorage().then((res)=>{
      let payload = {
        ID: this.orgObj.id,
        first_name: this.updateOrgform.value.firstName,
        last_name: this.updateOrgform.value.lastName,
        email: this.updateOrgform.value.email,
        phone_no: this.updateOrgform.value.phone,
        job_title: this.updateOrgform.value.jobTitle,
        employee: this.updateOrgform.value.employee,
        country: this.updateOrgform.value.country,
        company: this.updateOrgform.value.company,
        free_trial_mode: this.orgObj.free_trial_mode,
        updated_by: res.userId,
        update_ip_address: this.userIp,
        company_address: this.updateOrgform.value.company_address,
        company_logo: this.companyLogoId
      }

      //console.log(payload);
      this.helperService.loader();
      this.backendService.PutAPICall('updateApiOrganization', payload, res.token).subscribe(
        (data) => {
          this.helperService.closeLoader();
          if(this.isCompanyLogoPresentInServer){
            if(this.isEnableCompanyLogoChanges){
              this.updateExistingCompanyLogo();
            }
          }else{
            this.addNewCompanyLogo();
          }
          
          this.helperService.presentToast(data.msg, 2000);
          this.router.navigate(['/baseapp/organization']);
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  ngOnDestroy(){
    this.countriesApi.unsubscribe();
    this.editApi.unsubscribe();
    this.helperService.closeLoader();
  }

}
